import { VerticalSlug } from './types'

export const VERTICAL_SLUGS: readonly VerticalSlug[] = [
  'tienda',
  'servicios',
  'restaurante',
  'tecnologia',
  'salud',
  'educacion',
  'tienda_repuestos',
  'belleza_estetica',
  'bodegon_licoreria',
  'inmobiliaria',
  'ferreteria',
  'turismo_posadas',
  'otro',
] as const

export const VERTICAL_ALIASES: Record<string, VerticalSlug> = {
  // Tienda de Repuestos / Autopartes
  tienda_repuestos: 'tienda_repuestos',
  repuestos: 'tienda_repuestos',
  autopartes: 'tienda_repuestos',
  auto_partes: 'tienda_repuestos',
  repuesto: 'tienda_repuestos',
  repuestos_automotrices: 'tienda_repuestos',
  taller_repuestos: 'tienda_repuestos',
  repuestos_avila: 'tienda_repuestos',

  // Tienda / Moda
  tienda: 'tienda',
  ropa: 'tienda',
  moda: 'tienda',
  calzado: 'tienda',
  zapatos: 'tienda',
  ecommerce: 'tienda',
  comercio: 'tienda',

  // Restaurante / Alimentos
  restaurante: 'restaurante',
  restaurant: 'restaurante',
  restaurantes: 'restaurante',
  restaurants: 'restaurante',
  comida: 'restaurante',
  comidas: 'restaurante',
  alimentos: 'restaurante',
  cafeteria: 'restaurante',
  cafetería: 'restaurante',
  bar: 'restaurante',
  pizzeria: 'restaurante',
  pizzería: 'restaurante',
  hamburgueseria: 'restaurante',
  hamburguesería: 'restaurante',
  gastronomia: 'restaurante',
  gastronomía: 'restaurante',
  fast_food: 'restaurante',
  comida_rapida: 'restaurante',
  comida_rápida: 'restaurante',
  sushi: 'restaurante',
  panaderia: 'restaurante',
  panadería: 'restaurante',
  pasteleria: 'restaurante',
  pastelería: 'restaurante',
  reposteria: 'restaurante',
  repostería: 'restaurante',
  heladeria: 'restaurante',
  heladería: 'restaurante',

  // Tecnología
  tecnologia: 'tecnologia',
  tecnología: 'tecnologia',
  tech: 'tecnologia',
  technology: 'tecnologia',
  computacion: 'tecnologia',
  computación: 'tecnologia',
  celulares: 'tecnologia',
  telefonia: 'tecnologia',
  telefonía: 'tecnologia',
  electronica: 'tecnologia',
  electrónica: 'tecnologia',
  gadgets: 'tecnologia',
  software: 'tecnologia',

  // Servicios
  servicios: 'servicios',
  servicios_profesionales: 'servicios',
  consultoria: 'servicios',
  consultoría: 'servicios',
  agencia: 'servicios',
  legal: 'servicios',
  abogados: 'servicios',

  // Belleza y Estética
  belleza_estetica: 'belleza_estetica',
  belleza_estética: 'belleza_estetica',
  belleza: 'belleza_estetica',
  barberia: 'belleza_estetica',
  barbería: 'belleza_estetica',
  estetica: 'belleza_estetica',
  estética: 'belleza_estetica',
  spa: 'belleza_estetica',
  peluqueria: 'belleza_estetica',
  peluquería: 'belleza_estetica',
  salon_belleza: 'belleza_estetica',
  salón_belleza: 'belleza_estetica',
  unas: 'belleza_estetica',
  uñas: 'belleza_estetica',
  cejas: 'belleza_estetica',
  lashes: 'belleza_estetica',
  cosmetologia: 'belleza_estetica',
  cosmetología: 'belleza_estetica',

  // Bodegones y Licorerías
  bodegon_licoreria: 'bodegon_licoreria',
  bodegón_licorería: 'bodegon_licoreria',
  bodegon: 'bodegon_licoreria',
  bodegón: 'bodegon_licoreria',
  licoreria: 'bodegon_licoreria',
  licorería: 'bodegon_licoreria',
  minimarket: 'bodegon_licoreria',
  bebidas: 'bodegon_licoreria',
  licores: 'bodegon_licoreria',
  cerveza: 'bodegon_licoreria',
  snacks: 'bodegon_licoreria',
  importados: 'bodegon_licoreria',
  bodegon_express: 'bodegon_licoreria',

  // Ferretería y Materiales
  ferreteria: 'ferreteria',
  ferretería: 'ferreteria',
  materiales: 'ferreteria',
  construccion: 'ferreteria',
  construcción: 'ferreteria',
  electricidad: 'ferreteria',
  plomeria: 'ferreteria',
  plomería: 'ferreteria',
  pinturas: 'ferreteria',
  herramientas: 'ferreteria',
  ferretero: 'ferreteria',

  // Bienes Raíces e Inmobiliaria
  inmobiliaria: 'inmobiliaria',
  bienes_raices: 'inmobiliaria',
  bienes_raíces: 'inmobiliaria',
  inmuebles: 'inmobiliaria',
  propiedades: 'inmobiliaria',
  apartamentos: 'inmobiliaria',
  alquiler_inmuebles: 'inmobiliaria',
  venta_casas: 'inmobiliaria',
  oficinas: 'inmobiliaria',
  locales: 'inmobiliaria',

  // Turismo y Posadas
  turismo_posadas: 'turismo_posadas',
  turismo: 'turismo_posadas',
  posadas: 'turismo_posadas',
  hoteles: 'turismo_posadas',
  hospedaje: 'turismo_posadas',
  viajes: 'turismo_posadas',
  vacaciones: 'turismo_posadas',
  full_day: 'turismo_posadas',
  cayos: 'turismo_posadas',
  morrocoy: 'turismo_posadas',
  los_roques: 'turismo_posadas',
  merida: 'turismo_posadas',
  mérida: 'turismo_posadas',

  // Salud
  salud: 'salud',
  medicina: 'salud',
  clinica: 'salud',
  clínica: 'salud',
  dental: 'salud',
  odontologia: 'salud',
  odontología: 'salud',
  psicologia: 'salud',
  psicología: 'salud',
  veterinaria: 'salud',

  // Educación
  educacion: 'educacion',
  educación: 'educacion',
  cursos: 'educacion',
  academia: 'educacion',
  colegio: 'educacion',
  universidad: 'educacion',
  capacitacion: 'educacion',
  capacitación: 'educacion',
}

export function isValidVertical(value: string): value is VerticalSlug {
  return (VERTICAL_SLUGS as readonly string[]).includes(value)
}

/**
 * Normaliza cualquier string de tipo de negocio a un VerticalSlug canónico.
 * Si el valor es null, undefined, vacío o desconocido, devuelve 'otro'.
 * Nunca usa regex probabilísticos sobre texto libre.
 */
export function normalizeToVertical(value: string | null | undefined): VerticalSlug {
  if (!value) return 'otro'
  const trimmed = value.trim()
  if (!trimmed) return 'otro'

  const normalized = trimmed.toLowerCase().replace(/[\s-]+/g, '_')
  if (isValidVertical(normalized)) return normalized
  if (VERTICAL_ALIASES[normalized]) return VERTICAL_ALIASES[normalized]
  return 'otro'
}
